import { FC, ReactElement } from 'react'

import { Loader } from '../../../loaders'
import './mainBanner.css'

const LoaderBanner: FC = (): ReactElement => {
  return (
    <div className="banner banner-onthehub">
      <div className="banner-text-wrapper">
        <div className="banner-text">
          <span className="italian"></span>
          <span className="title roman"></span>
          <p></p>
        </div>
      </div>

      <Loader
        loaderType="tail"
        style={{
          width: '150px',
          height: '150px',
          position: 'absolute',
          zIndex: '1',
          background: 'rgba(0,0,0,0.3)',
          padding: '20px',
          borderRadius: '10px',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
    </div>
  )
}

export default LoaderBanner
